import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  headerContainerItems: ".animation--container-header > *",
  footerContainerItems: ".animation--container-footer > *",
  containerItems: ".animation--container > *",
  items: ".animation--item",
};

export default (node, offset) => {
  const delayOffsetStart = offset ? offset : 0;

  // Add the animation delay offset variables
  delayOffset(
    node,
    [
      selectors.headerContainerItems,
      selectors.containerItems,
      selectors.items,
      selectors.footerContainerItems
    ],
    delayOffsetStart
  );

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
